import { combineReducers } from 'redux';
import CoreReduxStore from '@/core/reducers/CoreReduxStore';
import TCoreReduxStore from '@/core/types/TCoreReduxStore';

const reduxStorages = new CoreReduxStore( { screenCode: "COM", serviceCode: "Lang" } as TCoreReduxStore )

/**
 * - Language api sinden alınan veriler burada depolanır.
 * - Herhangi bir sayfaya bağlı kalmaksızın verilerin depolanması için 
 *   screenCode COM(Common) ve serviceCode Lang(Langauge) olarak set edilmiştir.
 */

const LanguageStore = combineReducers({

    ...reduxStorages.LIST()

});

export default LanguageStore;